import { InjectionToken } from "@angular/core";

import { CoreConfigModel } from "./model";

export const CORE_CONFIG = new InjectionToken<CoreConfigModel>("coreConfig");

/**
 * @internal
 */
export const _CORE_CONFIG = new InjectionToken<CoreConfigModel | (() => CoreConfigModel)>("_coreConfigToken");
